import React from 'react';
import useApp from '../../store/app/appContext';
import TreatmentsProvider from '../../store/treatments/treatmentsProvider';
import UsersProvider from '../../store/users/usersProvider';
import ClinicsProvider from '../../store/clinics/clinicsProvider';
import PageWrapper from '../../containers/app/PageWrapper';
import TreatmentsList from '../../containers/treatments/TreatmentsList';

function TreatmentManagerPage() {  

  const { appState: { user, userAccount }} = useApp();

  if (!user) return '';
  if (!user._id) return '';
  
  return (
    <TreatmentsProvider>
      <UsersProvider>
        <ClinicsProvider>
          <PageWrapper navbar title={userAccount.isPatientOrPartner ? 'My treatments': 'Treatment Manager'}>
            <TreatmentsList />
          </PageWrapper>
        </ClinicsProvider>
      </UsersProvider>
    </TreatmentsProvider>
  )
}

export default TreatmentManagerPage;
